module.exports = __webpack_public_path__ + "img/smile-shop.574c225c.png";